﻿import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/carousel";
import Popover from "bootstrap/js/dist/popover";
import Modal from "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";

window.bootstrap = {
    Modal: Modal,
    Popover : Popover
};

const scrollup = document.getElementById("scrollup");
window.addEventListener('scroll', () => {
    if (window.scrollY > 10) {
        scrollup.style.display = "block";
    } else {
        scrollup.style.display = "none";
    }
});
scrollup.addEventListener('click', () => {
    event.preventDefault();
    window.scroll({ top: 0, behavior: 'smooth' });
});

